<template>
  <section class="k12-panel">
    <div class="k12-panel-header">
      <div class="k12-panel-title">
        <span class="k12-icon"><i class="fas fa-sticky-note"></i></span>
        <span>{{ $t('preInvoiceV2.remark') }}</span>
      </div>
    </div>
    <div class="k12-panel-body">
      <div class="ts-grid ts-grid-cols-1">
        <div>
          <label class="compact-label">{{ $t('preInvoiceV2.remark') }}</label>
          <a-textarea v-model="model.remark" :rows="2" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'RemarkSection',
  props: {
    model: { type: Object, required: true }
  }
}
</script>

<style scoped>
.compact-label {
  display: block;
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
}
</style>
